import { API_PROD_URL } from "src/utils/axios";

export const createFoldername = async (
  folderName: string,
  callback: (value: { loading: boolean; success: boolean; errorType?: string }) => void,
) => {
  try {
    // Step 1: Create folder
    const response = await fetch(`${API_PROD_URL}/create_folder`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        folder_path: folderName,
      }),
    });

    if (!response.ok) {
      callback({ loading: false, success: false, errorType: "create" });
      return;
    }
    callback({ loading: false, success: false });

    // Both steps succeeded
    callback({ loading: false, success: true });
  } catch (err) {
    console.error("Error creating folder or uploading files:", err);
    callback({ loading: false, success: false, errorType: "create" });
  }
};

export const fileUpload = async (
  folderName: string,
  selectedFiles: File[],
  callback: (value: { loading: boolean; success: boolean; errorType?: string }) => void,
) => {
  if (selectedFiles.length > 0) {
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file);
    });

    const uploadResponse = await fetch(`${API_PROD_URL}/upload_files/${folderName}`, {
      method: "POST",
      body: formData,
    });

    if (!uploadResponse.ok) {
      callback({ loading: false, success: false });
      return;
    }
    callback({ loading: false, success: true });
  }
};

export const fetchFiles = async (
  folderName: string,
  callback: (value: { loading: boolean; success: boolean; data?: [] }) => void,
) => {
  try {
    // Step 1: Create folder
    const response = await fetch(`${API_PROD_URL}/list_files/${folderName}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      callback({ loading: false, success: false });
      return;
    }

    const fileData = await response.json();

    // Both steps succeeded
    callback({ loading: false, success: true, data: fileData.files });
  } catch (err) {
    console.error("Error creating folder or uploading files:", err);
    callback({ loading: false, success: false });
  }
};
